import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ChevronDownIcon from 'lucide-react/dist/esm/icons/chevron-down';
import ChevronRightIcon from 'lucide-react/dist/esm/icons/chevron-right';

interface MobileFeaturesGroupProps {
  onClose: () => void;
}

export default function MobileFeaturesGroup({ onClose }: MobileFeaturesGroupProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="space-y-2">
      <button
        onClick={toggleExpanded}
        className="flex items-center justify-between w-full text-left py-2 text-joey-navy hover:opacity-80"
      >
        <span>Features</span>
        {isExpanded ? <ChevronDownIcon size={16} /> : <ChevronRightIcon size={16} />}
      </button>
      
      {isExpanded && (
        <div className="ml-4 space-y-2 border-l border-gray-200 pl-4">
          <Link to="/features/iphone-monitoring" className="block py-1 text-gray-600" onClick={onClose}>
            iPhone & iMessage Monitoring
          </Link>
          <Link to="/features/hows-my-child-report" className="block py-1 text-gray-600" onClick={onClose}>
            How's My Child? Report
          </Link>
          <Link to="/features/smart-alerts" className="block py-1 text-gray-600" onClick={onClose}>
            Smart Alerts
          </Link>
          <Link to="/features/contact-verification" className="block py-1 text-gray-600" onClick={onClose}>
            Contact Verification
          </Link>
          <Link to="/features/analytics" className="block py-1 text-gray-600" onClick={onClose}>
            Analytics
          </Link>
        </div>
      )}
    </div>
  );
}